import {
  HttpEventType,
  HttpInterceptorFn
} from '@angular/common/http';
import { map, catchError, throwError } from 'rxjs';
import { PROGRESS_BAR_SUBJECT } from '../app.component';

export const progressBarInterceptor: HttpInterceptorFn = (req, next) => {
  const subject = PROGRESS_BAR_SUBJECT;

  return next(req).pipe(
    map((event) => {
      if (event.type === HttpEventType.Sent) {
        subject.next(true);
      }

      if (event.type === HttpEventType.Response) {
        subject.next(false);
      }

      return event;
    }),
    catchError((error) => {
      subject.next(false);

      return throwError(() => error);
    })
  );
};
